import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpResponseStatus } from './http-data.service';

@Injectable()
export class HttpDataInterceptor implements HttpInterceptor {
  constructor() {
    /**/
  }

  public intercept(req:HttpRequest<any>, next:HttpHandler):Observable<HttpEvent<any>> {
    return next.handle(req)
      .pipe(
        map((event:HttpEvent<any>) => {
          if (event instanceof HttpResponse && event.body?.status === HttpResponseStatus.FAIL) {
            throw new HttpErrorResponse({
              error: event.body,
              headers: event.headers,
              status: event.status,
              statusText: event.body?.status,
              url: event.url
            });
          }

          return event;
        })
      );
  }
}